import React from "react"
import { useField } from "formik"
import Styles from "./inputCheckbox.module.scss"

const InputCheckbox = ({ message, ...props }) => {
  const [field] = useField(props)
  const handleChange = e => field.onChange(e)
  return (
    <div className={Styles.wrapper}>
      <input type="checkbox" name={field.name} id={field.name} onChange={handleChange} />
      <label htmlFor={field.name}>{message}</label>
    </div>
  )
}

export default InputCheckbox
